import { Icon } from "@iconify/react";
import { Typography } from "@mui/material";
import '../../../styles/Auth/categoryPopup.css';

const ViewsubCategoryPopup = ({ data, onClose }) => {
    return (
        <div className="category-detail-overlay">
            <div className="category-detail-modal">
                <button className="category-detail-close" onClick={onClose}>
                    <Icon icon="solar:close-circle-bold-duotone" width={32} height={32} />
                </button>

                <div className="category-detail-header">
                    <div className="category-detail-image-container">
                        <img
                            src={data?.subCategoryImageObject?.uri ? `${process.env.REACT_APP_API_URL}${data.subCategoryImageObject.uri}` : "/assets/placeholder.png"}
                            alt={data.subCategoryName || data.name}
                            onError={(e) => { e.target.onerror = null; e.target.src = "/assets/placeholder.png"; }}
                            className="category-detail-img"
                        />
                    </div>
                    <Typography variant="h5" className="category-detail-title">
                        {data.subCategoryName || data.name}
                    </Typography>
                </div>

                <div className="category-detail-content">
                    <div className="category-detail-stats">
                        <div className="stat-card">
                            <Icon icon="solar:folder-bold-duotone" className="stat-icon" />
                            <div className="stat-info">
                                <span className="stat-label">Main Category</span>
                                <span className="stat-value">{data.categoryId?.name || data.categoryId?.categoryName || "N/A"}</span>
                            </div>
                        </div>
                    </div>

                    {data.description && (
                        <div className="category-detail-section">
                            <label><Icon icon="solar:document-text-bold-duotone" /> Description</label>
                            <p>{data.description}</p>
                        </div>
                    )}

                    <div className="category-detail-stats">
                        <div className="stat-card">
                            <Icon icon="solar:shop-2-bold-duotone" className="stat-icon" />
                            <div className="stat-info">
                                <span className="stat-label">Status</span>
                                <span className={`stat-value ${data.isActive ? 'active' : 'inactive'}`}>
                                    {data.isActive ? 'Active' : 'Inactive'}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="category-detail-footer">
                    <button className="category-detail-action-btn" onClick={onClose}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ViewsubCategoryPopup;